import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';
import { ZeroPayMarketingGetResponse } from './models/marketing_downloads_get';
import {
  ZeroPayMarketingTypeGetResponse,
  ZeroPayMarketingTypeGetResponseData,
} from './models/marketing_downloads_get_types';

@Component({
  selector: 'app-marketing-downloads',
  templateUrl: './marketing-downloads.component.html',
  styleUrls: ['./marketing-downloads.component.scss'],
})
export class MarketingDownloadsComponent implements OnInit {
  files: any[] = [];

  constructor(private api: ApiService) {}

  public loading = false;

  async ngOnInit(): Promise<void> {
    const types: ZeroPayMarketingTypeGetResponse =
      await this.api.get<ZeroPayMarketingTypeGetResponse>(
        `${environment.adminUrl}/zeropay/marketing/get/type`,
        new HttpHeaders()
      );

    const storeData: ZeroPayMarketingGetResponse =
      await this.api.get<ZeroPayMarketingGetResponse>(
        `${environment.adminUrl}/zeropay/marketing/get`,
        new HttpHeaders()
      );

    const stores: any[] = [];
    const grouped: any = this.groupBy(storeData.data, 'marketingTypeID');
    const keys = Object.keys(grouped);

    for (let i = 0; i < keys.length; i++) {
      const cat = types.data?.find(
        (x: ZeroPayMarketingTypeGetResponseData) => x.id == +keys[i]
      );

      stores.push({
        type: cat,
        files: grouped[keys[i]],
      });
    }

    stores.sort((n1, n2) => {
      if (n1.type.name > n2.type.name) {
        return 1;
      }

      return -1;
    });

    this.files = [];
    this.files = [...stores];
    this.files.sort((a: any, b: any) => {
      if (a.category.priority > b.category.priority) return 1;
      if (a.category.priority < b.category.priority) return -1;

      return 0;
    });

    console.log(this.files);
  }

  groupBy(xs: any, key: any) {
    return xs.reduce(function (rv: any, x: any) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }
}
